import { render } from "./MyTasksCard.vue?vue&type=template&id=0b19c83d&scoped=true"
import script from "./MyTasksCard.vue?vue&type=script&lang=js"
export * from "./MyTasksCard.vue?vue&type=script&lang=js"

import "@/assets/css/commandcenter/commandcenter.css?vue&type=style&index=0&lang=css&external"
import "./MyTasksCard.vue?vue&type=style&index=1&id=0b19c83d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b19c83d"]])

export default __exports__